var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavwallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 21,
    fill: "#302F2F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 243"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 78",
    d: "M-1190 -25C-1190 -39.3594 -1178.36 -51 -1164 -51H515C529.359 -51 541 -39.3594 541 -25V63H-1190V-25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 250"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 83",
    x: -15,
    y: -16,
    width: 157,
    height: 52,
    rx: 26,
    fill: "#0989C2",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23 3.81818H3C2.73478 3.81818 2.48043 3.71761 2.29289 3.5386C2.10536 3.35959 2 3.1168 2 2.86364C2 2.61048 2.10536 2.36768 2.29289 2.18867C2.48043 2.00966 2.73478 1.90909 3 1.90909H20C20.2652 1.90909 20.5196 1.80852 20.7071 1.62951C20.8946 1.4505 21 1.20771 21 0.954545C21 0.701384 20.8946 0.458592 20.7071 0.27958C20.5196 0.100568 20.2652 0 20 0H3C2.20435 0 1.44129 0.301704 0.87868 0.83874C0.316071 1.37578 0 2.10415 0 2.86364V18.1364C0 18.8958 0.316071 19.6242 0.87868 20.1613C1.44129 20.6983 2.20435 21 3 21H23C23.5304 21 24.0391 20.7989 24.4142 20.4408C24.7893 20.0828 25 19.5972 25 19.0909V5.72727C25 5.22095 24.7893 4.73537 24.4142 4.37734C24.0391 4.01932 23.5304 3.81818 23 3.81818ZM18.5 13.3636C18.2033 13.3636 17.9133 13.2797 17.6666 13.1223C17.42 12.965 17.2277 12.7414 17.1142 12.4798C17.0007 12.2181 16.9709 11.9302 17.0288 11.6525C17.0867 11.3747 17.2296 11.1196 17.4393 10.9194C17.6491 10.7191 17.9164 10.5828 18.2074 10.5275C18.4983 10.4723 18.7999 10.5006 19.074 10.609C19.3481 10.7174 19.5824 10.9009 19.7472 11.1363C19.912 11.3718 20 11.6486 20 11.9318C20 12.3116 19.842 12.6757 19.5607 12.9443C19.2794 13.2128 18.8978 13.3636 18.5 13.3636Z",
    fill: "#056E9C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavwallet);
export default __webpack_public_path__ + "static/media/Navwallet.041a70b088603ffdb9f037e10050046a.svg";
export { ForwardRef as ReactComponent };